export const invoice = {
  enter_note: "Enter a note...",
  enter_payment_terms: "Enter payment terms...",
  enter_execution_conditions: "Enter execution conditions...",
  invoice_list: "Invoice list",
  btn_signin: "Connexion",
  btn_signup: "Créer un compte",
  go_to_dashboard: "Tableau de bord",

  txt_header_section_1: "Votre outil de",
  txt_header_section_2: "Facturation",
  txt_description:
    "Nous définissons le problème, l'objectif et élaborons une proposition pour l'utilisateur, une fois que nous avons compris ses besoins. ",
  update_invoice: "Modifier la facture",
  email: "Email",
  title: "Invoices",
  search_placeholder: "Search",
  all: "All",
  draft: "Drafts",
  finalized: "To validate",
  paid: "Validated",
  to_pay: "Published",
  client_name: "Client",
  empty_title: "Create an invoice",
  empty_description: "Easily create and send invoices to your clients",
  choose_client: "Choose a client",
  create_button: "Create invoice",
  company_name: "Company name",
  new_invoice: "New sales invoice",
  recipient: "Recipient",
  new_client: "New client",
  choose_company: "Select a company",
  new_companies: "New company",
  informations: "Information",
  currency: "Currency (required)",
  checkboxTVA: "VAT not applicable",
  seller_name: "Seller name",
  seller_email: "Seller email",
  seller_address: "Seller address",
  invoice_number: "Invoice number",
  command_number: "Order number",
  invoice_date: "Invoice date",
  due_date_invoice: "Due date",
  type_invoice: "Invoice type",
  articles: "Items",
  type: "Type",
  quantity: "Quantity",
  price_ht: "Unit price (excl. VAT)",
  total_ht: "Total excl. VAT",
  tva: "VAT",
  debours: "Disbursements",
  reduction: "Discount (%)",
  add_debours: "+ Add disbursement",
  regulation: "Payment",
  conditions: "Payment terms",
  regulation_mode: "Payment method",
  late_interests: "Late interest",
  no_late_interests: "No late interest",
  bank_account: "Bank account (IBAN)",
  default_conditions: "45 days end of month",
  default_regulation_mode: "Bank transfer",
  client: "Client",
  client_name_label: "Client name",
  client_email: "Client email",
  client_address: "Client address",
  amount: "Amount",
  due_date: "Due date",
  status: "Status",
  submit: "Save invoice",
  document_text: "Text displayed on the document",
  keywords: "Keywords",
  choose_keywords: "Add/Select keywords",
  notes: "Notes",
  payment_solution: "Quick payment solution",
  add_line: "+ Add a line",
  end_date: "To",
  start_date: "Invoice date",
  // UI actions/buttons
  cancel: "Cancel",
  preview: "Preview",
  save_draft: "Save draft",
  creating: "Creating...",
  finalize: "Finalize invoice",
  remove: "Delete",
  close: "Close",
  loading_companies: "Loading companies...",
  error_loading_companies: "Error loading companies",
  loading_clients: "Loading clients...",
  error_loading_clients: "Error loading clients",
  add_article: "Add item",
  custom_fields: "Add custom fields",
  no_clients_for_company: "No clients for this company",
  engagement_id: "Purchase Order",
  total: "Total (incl. VAT)",
  add_field: "Add field",
  payment_info: "Payment information",
  bank_name: "Name",
  payment_terms: "Payment terms",
  note: "Note / Special mentions",
  label: "Label",
  value: "Value",

  details_title: "Invoice details",
  details_personnel: "Personnal details",
  select: "select a choice",
  select_offer: "select an offer",
  Offre_title: "Offer:",
  other: "Other",
  due_duration: "Due duration ",
  no_invoices_in_this_tab: "No invoices in this tab",
  missing_fields_description:
    "Please fill in all the required fields before saving the invoice.",
  invalid_ht: "You must add offers to your invoice",
  description: "Description",
  product_service: "Product/Service",
  tva_percentage: "TVA (%)",
  edit: "Edit",
  consult: "Consult",
  view_receipt: "View receipt",
  select_client_first: "Please select a company first",
  name_destinataire: "Destinataire",
  siren: "SIREN",
  siret: "SIRET",
  client_type: "Client type",
  vat_number: "VAT Number",
  phone: "Phone",
  rm: "Trade Register",
  laborCost: "Labor cost",
  travelExpenses: "Travel expenses",

  number_prefix: "No. ",
  pending: "Pending",
  emitter: "Sender",
  receiver: "Recipient",
  company: "Company",
  address: "Address",
  info: "Information",
  details: "Details",
  unit_price: "Unit Price (excl. tax)",
  vat_percent: "VAT (%)",
  discount: "Discount",
  total_ttc: "Total incl. tax",
  total_vat: "Total VAT",
  additional_fees: "Additional Fees",
  payment_method: "Payment method",
  bank_info: "Bank details",
  bank: "Bank",
  iban: "IBAN",
  bic: "BIC",
  company_signature: "Company Signature",
  page: "Page",
  number: "Number ",

  quote: {
    quote: "Quote ",
  },
  credit: {
    credit_note: "Credit Note",
  },
  invoice: "invoice",

  no_payment_method: "No payment method provided",
  no_note: "No note provided",
  total_tva: "TVA total",
  executionConditions: "Execution conditions",
  no_companies_available: "No companies available",
  total_credit: "Total credit note",

  partially_paid: "Partially paid",
  unpaid: "Unpaid",
  paid_status: "Paid",

  draftt: "Draft",
  to_validate: "To validate",
  validated: "Validated",
  published: "Published",

  column_ref: "Ref",
  column_ref_invoice: "Invoice Ref",
  column_client: "Client",
  column_payment_status: "Payment Status",
  column_total_ttc: "Total (TTC)",
  column_invoice_date: "Invoice Date",
  column_invoice_status: "Invoice Status",
  column_credit_notes: "Credit Notes",

  error_company_required: "Please select a company.",
  error_client_required: "Please select a client.",
  error_date_facturation_required: "Please choose a billing date.",
  error_date_echeance_required: "Please choose a due date.",
};
